import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useSessionStorage } from '@/hooks'
import type { ProjectWorkspace } from './projectWorkspaceUtils'

export type UserLinkedOrganisation = RestSchemas['Messages.Projects.UserLinkedOrganisation']

// Manual type override because workspace payloads use camelCase keys not reflected in the generated schema.
export type UserLinkedProject = Omit<RestSchemas['Messages.Projects.UserLinkedProject'], 'workspaces'> & {
  workspaces: ProjectWorkspace[]
}

type UserLinkedProjectWithLegacyOrgId = UserLinkedProject & {
  organisationId?: number
}

export function getProjectOrganisationId(project: UserLinkedProject): number | undefined {
  const legacyProject = project as UserLinkedProjectWithLegacyOrgId
  const organisationId = project.organisation_id ?? legacyProject.organisationId

  return organisationId != null && Number.isFinite(organisationId) ? organisationId : undefined
}

export function getOrganisationPermissions(
  organisations: UserLinkedOrganisation[],
  organisationId: number | undefined
): UserLinkedOrganisation | undefined {
  if (organisationId == null) {
    return undefined
  }

  return organisations.find((org) => org.organisationId === organisationId)
}

function useUserLinkedProjectsResponse() {
  const [sub] = useSessionStorage('sub', 0)
  const { getProjectsApiGetUserLinkedProjects } = useRestClient()
  const { data } = getProjectsApiGetUserLinkedProjects.useSuspenseQuery({ query: { userId: sub } })
  return data
}

export function useUserLinkedOrganisations(): UserLinkedOrganisation[] {
  return useUserLinkedProjectsResponse().organisations
}

export function useUserLinkedProjects(): UserLinkedProject[] {
  return useUserLinkedProjectsResponse().projects as unknown as UserLinkedProject[]
}
